import { KeyboardEventHandler } from 'react';

/**
 * This is to provide tab navigation and keyboard interaction for autocomplete dropdown
 * when there's a selected value and the input is hidden.
 */

export default ({
  shouldBeFocusable,
  openMenu,
}: {
  shouldBeFocusable: boolean;
  openMenu?: () => void;
}) => {
  if (!shouldBeFocusable) {
    return {};
  }

  const onKeyDown: KeyboardEventHandler = (event) => {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault();
      openMenu?.();
    }
  };

  return {
    tabIndex: 0,
    onKeyDown,
  };
};
